import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { SweetalertCustom } from '@shared/utils/sweetalert-custom';

@Component({
  selector: 'app-autocomplete-chip',
  templateUrl: './autocomplete-chip.component.html',
  styleUrls: ['./autocomplete-chip.component.scss']
})
export class AutocompleteChipComponent {
  @Input() form: FormGroup;
  @Input() name: string;
  @Input() url: string;
  @Input() customClass: string;
  @Input() required: boolean = false;
  @Input() validateMessage: string;
  @Input() isOnlyView: boolean = false;
  @Input() fieldName: string;
  @Input() key: string;
  @Input() searchFor: string;
  @Input() params: any;
  @Input() label: any;
  @Input() msgRegistroJaSelecionado: string = "Este registro já existe na relação proposta!";

  @Output() onFocusOut = new EventEmitter<any>();
  @Output() onChange = new EventEmitter<any>();

  get chipControl(): FormControl {
    return this.form.get(this.name) as FormControl;
  }

  get autocompleteControl(): FormControl {
    return this.form.get(this.key) as FormControl;
  }

  addChip(event: any): void {
    let current = this.chipControl.value;
    if (!Array.isArray(current)) {
      current = [];
    }
    const alreadyExist = current.find((aee) => aee.id === event.id);
    if (alreadyExist) {
      this.showAlreadyExistsMessage();
      return;
    }
    this.chipControl.setValue([...current, event]);
    this.autocompleteControl.reset();
    this.autocompleteControl.clearValidators();
    this.autocompleteControl.updateValueAndValidity();
    this.onChange.emit(event);
  }

  removeChip(item: any): void {
    this.chipControl.setValue(
      this.chipControl.value.filter((aee) => aee.id !== item.id)
    );
    if (this.chipControl.value.length === 0) {
      this.autocompleteControl.setValidators(this.required ? [ ] : null);
      this.autocompleteControl.updateValueAndValidity();
    }
    this.onChange.emit(item);
  }

  showAlreadyExistsMessage(): void {
    SweetalertCustom.newShowAlertConfirm('warning', "Atenção!", this.msgRegistroJaSelecionado, "OK");
  }
}
